module.exports = __webpack_public_path__ + "img/icon_tiktok.39188b8f.png";